// import { name } from "file-loader";

const data = {
  goods: [
   
    {
      name: '风云VIP',
      icon: '买1得5',
      content: [
        '解锁所有付费会员权益',
        '赠送3个月会员时长',
        '赠送全套专属涨停大礼包'
      ],
      originPrice: '5188',
      price: '3988',
      skuId: 3,
      spuId: 1
    },
    {
      name: '研报畅读',
      icon: '买1得2',
      content: [
        '解锁所有付费研报',
        '赠送锦鲤卡',
        '赠送3个月会员时长'
        
      ],
      originPrice: '1688',
      price: '1388',
      skuId: 6,
      spuId: 2
    },
    {
      name: '短线挖掘',
      icon: '买1得2',
      content: [
        '解锁所有掘金付费文章',
        '查看常山每日复盘文章',
        '赠送3个月会员时长'
      ],
      originPrice: '1388',
      price: '1188',
      skuId: 81,
      spuId: 26
    },
    {
      name: '吾股复盘',
      icon: '买1得2',
      content: [
        '解锁4大复盘策略',
        '包含波段助手、筹码异动',
        '赠送3个月会员时长'
      ],
      originPrice: '1188',
      price: '1088',
      skuId: 52,
      spuId: 22
    },
    {
      name: '吾股排名',
      icon: '买1得2',
      content: [
        '实时查看个股排名异动',
        '根据个股排名趋势掘金',
        '赠送3个月会员时长'
      ],
      originPrice: '1188',
      price: '1088',
      skuId: 9,
      spuId: 3
    },
    {
      name: '红绿波段',
      icon: '买1得2',
      content: [
        '红多绿空一键便知',
        '支持多市场&全周期',
        '赠送3个月会员时长'
      ],
      originPrice: '1188',
      price: '1088',
      skuId: 66,
      spuId: 23
    },
    {
      name: '趋势拐点',
      icon: '买1得2',
      content: [
        '大数据分析个股趋势拐点',
        '赠送3个月会员时长'
      ],
      originPrice: '1188',
      price: '1088',
      skuId: 124,
      spuId: 27
    },
    {
      name: '跳空异动',
      icon: '买1得2',
      content: [
        '市场情绪探测器',
        '赠送3个月会员时长'
      ],
      originPrice: '1188',
      price: '1088',
      skuId: 91,
      spuId: 24
    },
    {
      name: '一阳指',
      icon: '买1得2',
      content: [
        '主力资金追踪器',
        '赠送3个月会员时长'
      ],
      originPrice: '1188',
      price: '1088',
      skuId: 94,
      spuId: 25
    },
  ],
 "rightsMap": [
    {
      "name": "付费研报免费读",
      "功能Id": "1",
      "icon": "icon-fufeiyanbao-01",
      "rights": [1,1,2,2,2,2,2,2,2,2,2,2,2],
     
    },
    {
      "name": "短线挖掘免费读",
      "功能Id": "2",
      "icon": "icon-duanxianwajue-01",
      "rights": [1,2,1,2,2,2,2,2,2,2,2,2,2],
      
    },
    {
      "name": "[指标] 波段助手",
      "功能Id": "3",
      "icon": "icon-boduanzhushou-01",
      "rights": [1,2,2,1,2,2,2,2,2,2,2,2,2],
      
    },
    {
      "name": "[指标] 股性追踪",
      "功能Id": "4",
      "icon": "icon-guxingzhuizong-01",
      "rights": [1,2,2,1,2,2,2,2,2,2,2,2,2],
     
    },
    {
      "name": "[指标] 筹码异动",
      "功能Id": "5",
      "icon": "icon-choumayidong-01",
      "rights": [1,2,2,1,2,2,2,2,2,2,2,2,2],
      
    },
    {
      "name": "[指标] 市场温度计",
      "功能Id": "5",
      "icon": "icon-shichangwenduji-01",
      "rights": [1,2,2,1,2,2,2,2,2,2,2,2,2],
      
    },
    {
      "name": "[指标] 红绿波段",
      "功能Id": "6",
      "icon": "icon-honglvboduan-01",
      "rights": [1,2,2,2,1,2,2,2,2,2,2,2,2],
      
    },
    {
      "name": "[指标] 跳空异动",
      "功能Id": "7",
      "icon": "icon-tiaokongyidong-01",
      "rights": [1,2,2,2,2,1,2,2,2,2,2,2,2],
      
    },
    {
      "name": "[指标] 趋势拐点",
      "功能Id": "8",
      "icon": "icon-qushiguaidian-01",
      "rights": [1,2,2,2,2,2,1,2,2,2,2,2,2],
     
    },
    {
      "name": "[指标] 一阳指",
      "功能Id": "9",
      "icon": "icon-yiyangzhi-01",
      "rights": [1,2,2,2,2,2,2,1,2,2,2,2,2],
      
    },
    {
      "name": "[指标] PE(市盈率)",
      "功能Id": "20",
      "icon": "icon-guzhiwajueji",
      "rights": [1,2,2,2,2,2,2,2,2,1,2,2,2],
      
    },
    {
      "name": "[指标] PB(市净率)",
      "功能Id": "21",
      "icon": "icon-guzhiwajueji",
      "rights": [1,2,2,2,2,2,2,2,2,1,2,2,2],
     
    },
    {
      "name": "[指标] PS(市销率)",
      "功能Id": "22",
      "icon": "icon-guzhiwajueji",
      "rights": [1,2,2,2,2,2,2,2,2,1,2,2,2],
      
    },
    {
      "name": "[指标] 股息率",
      "功能Id": "23",
      "icon": "icon-guzhiwajueji",
      "rights": [1,2,2,2,2,2,2,2,2,1,2,2,2],
     
    },
    {
      "name": "[指标] 两融差额",
      "功能Id": "24",
      "icon": "icon-yirongshu",
      "rights": [1,2,2,2,2,2,2,2,2,2,1,2,2],
      
    },
    {
      "name": "[指标] 融资净买额",
      "功能Id": "25",
      "icon": "icon-yirongshu",
      "rights": [1,2,2,2,2,2,2,2,2,2,1,2,2],
      
    },
    {
      "name": "[指标] 融资交易比",
      "功能Id": "26",
      "icon": "icon-yirongshu",
      "rights": [1,2,2,2,2,2,2,2,2,2,1,2,2],
     
    },
    {
      "name": "排名异动",
      "功能Id": "10",
      "icon": "icon-paimingyidong-01",
      "rights": [1,2,2,2,2,2,2,2,1,2,2,2,2],
     
    },
    {
      "name": "排名趋势",
      "功能Id": "11",
      "icon": "icon-paimingqushi-01",
      "rights": [1,2,2,2,2,2,2,2,1,2,2,2,2],
      
    },
    {
      "name": "大鳄周边",
      "功能Id": "12",
      "icon": "icon-daezhoubian",
      "rights": [1,2,2,2,2,2,2,2,2,2,2,1,2],
     
    },
    {
      "name": "会员尊享标识",
      "功能Id": "12",
      "icon": "icon-huiyuanzunxiangbiaoshi-01",
      "rights": [1,1,1,1,1,1,1,1,1,1,1,1,1],
     
    },
    {
      "name": "自选上限",
      "功能Id": "13",
      "icon": "icon-zixuanshangxian-01",
      "rights": [1,1,1,1,1,1,1,1,1,1,1,1,1],
     
    },
    {
      "name": "自选分组上限",
      "功能Id": "14",
      "icon": "icon-fenzushangxian-01",
      "rights": [1,1,1,1,1,1,1,1,1,1,1,1,1],
     
    },
    {
      "name": "赠送积分",
      "功能Id": "15",
      "icon": "icon-jifen-01",
      "rights": [1,1,1,1,1,1,1,1,1,1,1,1,1],
      
    },
    {
      "name": "大鳄问股(VIP问句)",
      "功能Id": "16",
      "icon": "icon-daewengu-01",
      "rights": [1,2,2,3,2,3,2,3,3,2,2,2,2],
     
    },
    {
      "name": "盯盘提醒（策略）",
      "功能Id": "17",
      "icon": "icon-dingpantixing-01",
      "rights": [1,1,3,3,3,3,3,3,3,3,3,3,3],
      
    }

  ],
  "tableGoods": ["风云VIP","研报畅读","短线挖掘","吾股复盘","红绿波段","跳空异动","趋势拐点","一阳指","吾股排名", "估值挖掘机", "易融术","大鳄周边","锦鲤卡"]
}


export default data;


// WEBPACK FOOTER //
// ./src/views/activity_139/goods.js